export const normalizeAgentListResponse = (payload) => {
  let value = payload;
  if (typeof value === 'string') {
    try {
      value = JSON.parse(value);
    } catch (_error) {
      return [];
    }
  }
  if (Array.isArray(value)) return value.filter((agent) => agent && typeof agent === 'object');
  const list = value?.agents || value?.data || value?.items || value?.results;
  if (Array.isArray(list)) return list.filter((agent) => agent && typeof agent === 'object');
  return [];
};

export const normalizeAgentCard = (agent = {}, index = 0) => {
  const id = String(agent.id || agent._id || `agent-${index}`);
  const name = String(agent.name || 'Untitled Agent');
  const stats = agent.stats && typeof agent.stats === 'object' ? agent.stats : {};
  return {
    ...agent,
    id,
    name,
    description: String(agent.description || ''),
    status: String(agent.status || 'active'),
    callsHandled: agent.callsHandled ?? stats.calls_handled ?? 0,
    avgLatency: agent.avgLatency ?? stats.avg_latency ?? 0,
    successRate: agent.successRate ?? stats.success_rate ?? 0,
  };
};

export const normalizeAgentListForDisplay = (payload) => (
  normalizeAgentListResponse(payload).map((agent, index) => normalizeAgentCard(agent, index))
);

export const dedupeAgentsById = (agents = []) => {
  const uniqueAgents = [];
  const seenIds = new Set();
  normalizeAgentListForDisplay(agents).forEach((agent, index) => {
    const id = agent.id || `agent-${index}`;
    if (!seenIds.has(id)) {
      seenIds.add(id);
      uniqueAgents.push(agent);
    }
  });
  return uniqueAgents;
};
